import { useQuery } from '@tanstack/react-query'
import { OptionsApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { queryKeyPrefix } from '../tanStackQuery/queryKeyPrefix'

// 特に理由はないが、そこまでリアルタイム性が求められないため、とりあえず30分のキャッシュを設定。
const STALE_TIME_MILLIS = 30 * 60 * 1000 // 30分

type Params = {
  startDate: Date
  endDate: Date
}

const getQueryKey = (params: Params) => {
  const { startDate, endDate } = params
  return [...queryKeyPrefix.optionUsages, startDate, endDate] as const
}

export const useOptionUsages = (params: Params) => {
  const { startDate, endDate } = params

  return useQuery({
    queryKey: getQueryKey(params),
    queryFn: () =>
      baseClient
        .getApi(OptionsApi, true)
        .getOptionUsages({ startDate, endDate }),
    staleTime: STALE_TIME_MILLIS,
    gcTime: Infinity,
  })
}
